query ListMyAssets {
  assets: StreamToolsListMyAssets {
    assetId
    fileName
    contentType
    sizeBytes
    publicUrl
    createdAt
    references {
      elementKind
      elementId
      elementName
      eventId
      eventName
    }
    usedByMerchBoards
    replacedByAssetId
    replacedAt
    replacesAssetId
  }
}
